package com.essntl.features.supplier.domain.model

data class SupplierFilterOptions(
    val searchText: String = "",
    val selectedCategoryIds: Set<String> = emptySet(),
    val selectedAreaIds: Set<String> = emptySet(),
)
